import { render, staticRenderFns } from "./EventStorming.vue?vue&type=template&id=77d1d05b&"
import script from "./EventStorming.vue?vue&type=script&lang=js&"
export * from "./EventStorming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports